export default {
    contractForm: {
        editTitle: 'Uredi ugovor',
        newTitle: 'Novi ugovor',
        saveRejected: 'Spremanje odbijeno',
        counterparty: 'Druga strana',
        counterpartyEic: 'EIC druge strane',
        externalDealId: 'Vanjski ID posla',
        country: 'Država',
        side: 'Strana',
        productType: 'Vrsta proizvoda',
        tenor: 'Rok',
        deliveryPeriod: 'Razdoblje isporuke',
        from: 'OD',
        to: 'DO',
        profileSource: 'Izvor profila',
        internalReference: 'Interna referenca',
        internalReferencePlaceholder: 'PO / tiket / slobodan tekst',
        tradeDate: 'Datum trgovanja',
        attachments: 'Privici',
        attachmentsHint: 'Zalijepite URL-ove dokumenata (PDF / e-pošta / Excel) — do 20 po ugovoru.',
        mtuFill: 'MTU popuna (MW)',
        price: 'Cijena (€/MW)',
        currency: 'Valuta',
        customHelperNote: 'Binovi će se postaviti na ekranu uređivača nakon Nastavi.',
        reclassifyHint: 'Država se može ponovno klasificirati (HR ↔ SI). Promjena ponovno razrješava profil.',
        reclassifyNote: 'Ponovna klasifikacija {from} → {to} ponovno razrješava profil ovog ugovora prema novom tržišnom kalendaru (drugačiji skup vršnih/prazničnih dana) i premješta njegovu poziciju između knjiga država. Zahtijeva prava odobravanja.',
        dateLockedNote: 'Raspon isporuke ne može se promijeniti za MANUAL_BILATERAL ugovor — njegovi binovi vezani su za ovaj prozor. Za drugačiji raspon, stvorite novi ugovor.',
        mtuFillCustomHint: 'Ručno postavite binove u uređivaču.',
        mtuFillActiveHint: 'Svaki aktivni {productType} MTU postavljen je na ovu vrijednost. Ukupno se izračunava automatski.',
        overlapDetected: 'Otkriveno preklapanje obveza',
        submitting: 'Slanje…',
        saveChanges: 'Spremi promjene',
        continue: 'Nastavi →',
        selectCountry: 'Odaberite HR ili SI',
        counterpartyRequired: 'Druga strana je obavezna',
        startDateRequired: 'Datum početka je obavezan',
        endDateRequired: 'Datum završetka je obavezan',
        endAfterStart: 'Datum završetka mora biti na ili nakon datuma početka',
        mtuFillPositive: 'MTU popuna mora biti veća od nule',
        pricePositive: 'Cijena mora biti veća od nule',
        amendContractIdRequired: 'način izmjene zahtijeva contractId svojstvo ili initial.id',
        unknownError: 'Nepoznata pogreška',
        contractAmended: 'Ugovor izmijenjen',
        contractCreated: 'Ugovor stvoren',
    },
}
